<template>
  <component :is="type" v-bind="linkProps(to)">
    <slot />
  </component>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    // 判断是否是外部链接
    isExternal() {
      return /^(https?:|mailto:|tel:)/.test(this.to);
    },
    // 如果是外部链接则渲染为 a 标签，否则渲染为 router-link
    type() {
      if (this.isExternal) {
        return "a";
      }
      return "router-link";
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: "_blank", // 新窗口打开
          rel: "noopener"   // 安全增强
        };
      }
      return {
        to: to
      };
    }
  }
};
</script>
